<template>
  <div class="container">
    <div class="top">
      <div class="serviceName">
        <p>やまなしデータプラットフォーム</p>
      </div>
      <div class="about">
        <p>やまなしデータ<br />プラットフォームとは</p>
      </div>
      <div class="explanation">
        <p>
          本サイトでは、山梨県の保有するオープンデータを利活用可能な形で
          公開しています。<br />
          データは知恵・価値・競争力の源泉であるとともに、地域課題の解決や
          オープンイノベーションの実現など、日本の社会課題を解決するための
          切り札として位置づけられています。<br />
          山梨県のデータ利活用が促進されるよう、本サイトを通じてデータを
          発信していきます。
        </p>
      </div>
    </div>
    <div class="maintenance" v-if="maintenanceFlag">
      <p class="smallTitleMaintenance">{{ maintenanceTitle }}</p>
      <div class="maintenanceExplane">
        <div class="maintenanceItem">
          <b>予定時刻</b>
          <p>{{ maintenanceDate }}</p>
        </div>
        <div class="maintenanceItem">
          <b>内容・影響</b>
          <p>
            {{ maintenanceContext }}
          </p>
        </div>
      </div>
    </div>
    <div class="features">
      <p class="smallTitle fueature">3つの機能</p>
      <div class="featureItems">
        <div class="featureImage dashboard"></div>
        <p class="featureTitle dashboard">ダッシュボード機能</p>
        <p class="featureExplane dashboard">
          オープンデータを可視化し、ダッシュボードとして提供しています。
        </p>
        <button
          class="fueature-b button dashboard"
          @click="link('/dashboard', false)"
        >
          ダッシュボードへ
        </button>
        <div class="featureImage datacatalog"></div>
        <p class="featureTitle datacatalog">データカタログ機能</p>
        <p class="featureExplane datacatalog">
          オープンデータをカタログサイトとして公開しています。<br />誰でもダウンロード可能です。
        </p>
        <button
          class="fueature-b button datacatalog"
          @click="link('https://catalog.dataplatform-yamanashi.jp/', true)"
        >
          データカタログサイトへ<v-icon icon="mdi-open-in-new"></v-icon>
        </button>
        <div class="featureImage api"></div>
        <p class="featureTitle api">API機能</p>
        <p class="featureExplane api">
          APIを用いてオープンデータを取得することができます。<br />
          開発者ポータルから利用方法を確認することができます。
        </p>
        <button
          class="fueature-b button api"
          @click="link('/developer-portal/release', false)"
        >
          開発者ポータルへ
        </button>
      </div>
    </div>
    <div class="contactSection" id="contact">
      <p class="smallTitle contact">問い合わせ</p>
      <div class="contactItems">
        <p class="contactExplane">
          APIの利用前申請や本サイトに関するご質問については以下よりお問合せください。
        </p>
        <p class="contactAddress">山梨県 ＤＸ・情報政策推進統括官（ＤＸ推進）</p>
        <button class="contact-b button" @click="mail()">
          <v-icon icon="mdi-email-outline"></v-icon>お問合せはこちら
        </button>
      </div>
      <div class="contactDescription">
        <u>お問合せの際は、以下の情報をフォームに従い記載願います</u>
        <ol>
          <li>
            <span><b>API利用前申請</b></span>
            <p>APIの利用申請については、以下のページをご覧ください。</p>
            <p>
              <a
                href="https://dataplatform-yamanashi.jp/developer-portal/howtouse"
                >開発者ポータルサイト（利用手順）</a
              >
            </p>
          </li>
          <li>
            <span><b>不具合やシステムの動作に関するお問合せ</b></span>
            <ul>
              <li>お名前</li>
              <li>所属組織（会社・大学・団体 等）</li>
              <li>ご連絡できる電話番号</li>
              <li>ご連絡できるメールアドレス</li>
              <li>ご利用の端末装置（パソコン／スマートフォン等）</li>
              <li>ご利用の端末装置のOS（Windows／Android／iOS等）</li>
              <li>ご利用のブラウザ種別（Google chrome／Firefox／Microsoft Edge／Safari等）</li>
              <li>ご利用のブラウザバージョン</li>
              <li>ご利用の通信環境（個人契約のインターネット回線／個人契約の携帯キャリア回線／所属法人のネットワーク経由等）</li>
              <li>お問合せ内容（できるだけ詳細にお願いいたします）<br />
                （不具合に関するお問い合わせの場合は以下の情報も可能な限りお知らせください）
              </li>
              <li>事象の発生時刻</li>
              <li>事象の再現性（常に発生／不定期・特定の条件で発生等）</li>
              <li>ご利用できないサービスのURL（例：https://yamanashi-dataplatform.jp/aaa/bbb）</li>
              <li>（API接続の場合）ご利用できないアクセス先に関する情報（URL、ヘッダー、クエリ）</li>
            </ul>
          </li>

          <li>
            <span><b>その他問い合わせ</b></span>
            <ul>
              <li>お名前</li>
              <li>所属組織（会社・大学・団体 等）</li>
              <li>ご連絡できる電話番号</li>
              <li>ご連絡できるメールアドレス</li>
              <li>お問合せ内容（できるだけ詳細にお願いいたします）</li>
            </ul>
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      maintenanceFlag: false,
      maintenanceDate: "",
      maintenanceContext: "",
      maintenanceTitle: "",
    };
  },
  methods: {
    link(url, newTab) {
      if (newTab) {
        window.open(url, "_blank");
      } else {
        window.open(url, "_self");
      }
    },
    mail() {
      //location.href = "https://forms.office.com/pages/responsepage.aspx?id=RXGmqaZ1j0-txs0C0tgebxXwkMTTIu9AvZjp1VvRnrZURTdNME9OVk1CSUVKUkFXMVpPSEZMVDhBRy4u";
      //window.open("https://forms.office.com/pages/responsepage.aspx?id=RXGmqaZ1j0-txs0C0tgebxXwkMTTIu9AvZjp1VvRnrZURTdNME9OVk1CSUVKUkFXMVpPSEZMVDhBRy4u", "_new");
      window.open("https://forms.office.com/Pages/ResponsePage.aspx?id=RXGmqaZ1j0-txs0C0tgebxXwkMTTIu9AvZjp1VvRnrZUOE9QM0JEMUlWMVNHSjVFOEpCMDBNT0xGMS4u", "_new");
    },
  },
  mounted() {
    axios
      .get("https://api.dataplatform-yamanashi.jp/info")
      .then((response) => {
        if (response.data.length == 0) {
          this.maintenanceFlag = false;
        } else {
          this.maintenanceFlag = true;
          this.maintenanceDate = response.data[0].date;
          this.maintenanceContext = response.data[0].context;
          this.maintenanceTitle = response.data[0].infoName;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.top {
  width: 100%;
  aspect-ratio: 6 / 4;
  background-image: url("../assets/image/topImage.jpg");
  background-size: contain;
  display: grid;
  grid-template-columns: 5fr 16fr 24fr 5fr;
  grid-template-rows: 9fr auto 1fr;
  grid-template-areas:
    "serviceName serviceName serviceName serviceName"
    ". about explanation ."
    ". . . .";
  align-self: center;
  color: white;
}

.serviceName {
  grid-area: serviceName;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 4vw;
  font-weight: 900;
}

.about {
  grid-area: about;
  font-size: 2.5vw;
  font-weight: 800;
}

.about > p {
  position: relative;
}

.about > p::after {
  content: "ABOUT US";
  font-size: 60%;
  color: #d9b97e;
  position: absolute;
  top: 100%;
  left: 0;
}

.explanation {
  grid-area: explanation;
  font-size: 1.5vw;
  font-weight: 600;
  line-height: 2.5vw;
}

.maintenance {
  width: 80%;
  margin-top: 120px;
  border: 1vw solid #8c031c;
  border-radius: 0 40px 0px 40px;
  padding: 4vw;
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: 1fr;
  column-gap: 10vw;
}

.maintenanceExplane {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 1.5vw;
  color: #0d0d0d;
  row-gap: 1vw;
}

.smallTitleMaintenance {
  font-size: 2.5vw;
  font-weight: 800;
  position: relative;
}

.features,
.contactSection {
  width: 80%;
  margin-top: 300px;
}

.smallTitle {
  font-size: 2.5vw;
  font-weight: 800;
  color: #072a40;
  position: relative;
}

.smallTitle.fueature::after {
  content: "FUNCTIONS";
  font-size: 60%;
  color: #d9b97e;
  position: absolute;
  top: 100%;
  left: 0;
}

.smallTitle.contact::after {
  content: "CONTACT";
  font-size: 60%;
  color: #d9b97e;
  position: absolute;
  top: 100%;
  left: 0;
}

.featureItems {
  margin-top: 100px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 5fr 1fr auto auto;
  grid-template-areas:
    "dashboadImage datacatalogImage apiImage"
    "dashboadTitle datacatalogTitle apiTitle"
    "dashboadExplane datacatalogExplane apiExplane"
    "dashboadButton datacatalogButton apiButton";
  justify-items: center;
  grid-column-gap: 20px;
}

.featureImage.dashboard {
  grid-area: dashboadImage;
}

.featureImage.datacatalog {
  grid-area: datacatalogImage;
}

.featureImage.api {
  grid-area: apiImage;
}

.featureImage {
  width: 60%;
  aspect-ratio: 1/1;
  background-size: contain;
  margin-bottom: 2vw;
}

.featureImage.dashboard {
  background-image: url("../assets/icon/dashboard.svg");
}

.featureImage.datacatalog {
  background-image: url("../assets/icon/datacatalog.svg");
}

.featureImage.api {
  background-image: url("../assets/icon/api.svg");
}

.featureTitle.dashboard {
  grid-area: dashboadTitle;
}

.featureTitle.datacatalog {
  grid-area: datacatalogTitle;
}

.featureTitle.api {
  grid-area: apiTitle;
}

.featureTitle {
  font-size: 1.5vw;
  font-weight: 600;
  color: #072a40;
}

.featureExplane.dashboard {
  grid-area: dashboadExplane;
}

.featureExplane.datacatalog {
  grid-area: datacatalogExplane;
}

.featureExplane.api {
  grid-area: apiExplane;
}

.featureExplane {
  font-size: 1vw;
  font-weight: 400;
  width: 80%;
  line-height: 2vw;
}

.fueature-b.button.dashboard {
  grid-area: dashboadButton;
}

.fueature-b.button.datacatalog {
  grid-area: datacatalogButton;
}

.fueature-b.button.api {
  grid-area: apiButton;
}

.button {
  background-color: #d9b97e;
  border-radius: 100px;
}

.fueature-b {
  font-size: 1.2vw;
  font-weight: 600;
  color: #072a40;
  width: 80%;
  padding: 4% 0;
  margin-top: 6vw;
}

.contact-b {
  font-size: 1.5vw;
  font-weight: 500;
  color: #072a40;
  width: 40%;
  padding: 1% 0;
  margin-bottom: 80px;
}

.contactItems {
  margin-top: 100px;
  width: 100%;
  display: flex;
  row-gap: 40px;
  flex-direction: column;
  align-items: center;
}

.contactExplane {
  font-size: 1.5vw;
}

.contactAddress {
  font-size: 2vw;
}

.contactDescription {
  font-size: 1.4vw;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  margin-bottom: 300px;
  padding-left: 1.5vw;
}

.contactDescription > ol {
  counter-reset: list-count;
  list-style: none;
}

.contactDescription > ol > li:before {
  content: "(" counter(list-count) ")";
  counter-increment: list-count;
  font-weight: bold;
}

.contactDescription > ol > li {
  padding-top: 1.5vw;
  padding-bottom: 1.5vw;
}
.contactDescription > ol > li > span {
  padding-left: 1vw;
}

.contactDescription > ol > li > ul {
  padding-left: 1.5vw;
  list-style: "-";
}

.contactDescription > ol > li > ul > li {
  padding-left: 1.5vw;
}
</style>
